const LAYERS = [
  'layer-building',
  'layer-real-estate',
  'layer-level',
  'colored-spaces-layer',
  'building-rooms',
  'layer-room'
]

export function getActiveLayers(map: mapboxgl.Map): string[] {
  const mapLayers = map.getStyle()?.layers ?? []
  const layerIntersection = mapLayers
    .filter((layer) => {
      return LAYERS.includes(layer.id)
    })
    .map((layer) => layer.id)
  return layerIntersection
}
